import { type Toast, type ToastKind, useToastStore } from "@/stores/toast.store";
import { CheckCircle2, Info, X, XCircle } from "lucide-react";

const KIND_STYLES: Record<ToastKind, { border: string; icon: JSX.Element }> = {
  success: {
    border: "border-l-emerald-500",
    icon: <CheckCircle2 className="w-5 h-5 text-emerald-500 flex-shrink-0" />,
  },
  error: {
    border: "border-l-red-500",
    icon: <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" />,
  },
  info: {
    border: "border-l-blue-500",
    icon: <Info className="w-5 h-5 text-blue-500 flex-shrink-0" />,
  },
};

function ToastCard({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss);
  const style = KIND_STYLES[toast.kind];

  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-lg border border-zinc-200 border-l-4 ${style.border} bg-white px-4 py-3 shadow-lg`}
    >
      {style.icon}
      <p className="flex-1 text-sm text-zinc-800 break-words">{toast.message}</p>
      <button
        type="button"
        onClick={() => dismiss(toast.id)}
        className="text-zinc-400 hover:text-zinc-700 transition-colors"
        aria-label="Dismiss notification"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2">
      {toasts.map((toast) => (
        <ToastCard key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
